<template>
  <div class="texture-bg-css">
    <div class="w">
      <div class="page-header"><Breadcrumb /></div>
      <!-- <router-view :key="$route.fullPath"></router-view> -->
      <PanoramasNav type="page"></PanoramasNav>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import PanoramasNav from '@/components/home/PanoramasNav'
export default {
  name: 'manage-panorama',
  components: {
    Breadcrumb,
    PanoramasNav
  },
  data() {
    return {}
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  mounted: function() {
    // console.log('mounted')
  }
}
</script>
<style lang="scss" scoped>
.texture-bg-css {
  padding-bottom: 80px;
  min-height: 80vh;
}
</style>
